import Vue from 'vue';
import Vuex from 'vuex';
import utils from '../utils'
Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        [utils.storeKeys.CLICKMENU]: {},
        [utils.storeKeys.EDEITFORM]: {},
        [utils.storeKeys.ADDFORM]: {},
        [utils.storeKeys.FORMINFO]: {},
        [utils.storeKeys.OTHERFORM]: {},
        [utils.storeKeys.CURRENTFORM]: {}
    },
    getters: {

    },
    mutations: {
        [utils.storeKeys.CLICKMENU](state, data) {
            state[utils.storeKeys.CLICKMENU] = data;
        },
        [utils.storeKeys.EDEITFORM](state, data) {
            state[utils.storeKeys.EDEITFORM] = data;
        },
        [utils.storeKeys.ADDFORM](state, data) {
            state[utils.storeKeys.ADDFORM] = data;
        },
        [utils.storeKeys.FORMINFO](state, data) {
            state[utils.storeKeys.FORMINFO] = data;
        },
        [utils.storeKeys.OTHERFORM](state, data) {
            state[utils.storeKeys.OTHERFORM] = data;
        },
        [utils.storeKeys.CURRENTFORM](state, data) {
            state[utils.storeKeys.CURRENTFORM] = data;
        },
        [utils.storeKeys.SETFORMDATA](state, param) {
            state[utils.storeKeys.CURRENTFORM][param.key] = param.value;
        }
    },
    actions: {

    }
})
export default store;


// WEBPACK FOOTER //
// ./src/store/index.js